export default __webpack_public_path__ + "static/media/bg-box-search-dark.e821828b.svg";